module.exports = "//cdn.mxpnl.com/static/asset-cache/408d69b33ad690099f9f0c845cd10142/iron/common/assets/images/charts/funnel-ttc.svg";